import React from 'react';
import {
  LBAlert,
  LBAlertCircleIcon,
  LBAlertTitle,
  LBAlertDescription
} from '@linearb/buzz';

const InvalidRepoNameWarning = () => {
  return (
    <LBAlert variant='destructive' className='flex items-start gap-2'>
      <div className='pt-1'>
        <LBAlertCircleIcon />
      </div>
      <div>
        <LBAlertTitle>Invalid repo name</LBAlertTitle>
        <LBAlertDescription>
          The organisation-level repository must be named exactly <b>cm</b>{' '}
          (lowercase). <br />
          Rename it, then try connecting gitStream again.
        </LBAlertDescription>
      </div>
    </LBAlert>
  );
};

export default InvalidRepoNameWarning;
